import styled from '@emotion/styled';

import { breakpoints } from '@coursera/cds-core';

export const Container = styled.div`
  margin: ${({ theme }) => 'var(--cds-spacing-400) 0 var(--cds-spacing-600)'};
  display: flex;
  gap: ${({ theme }) => 'var(--cds-spacing-800)'};
  justify-content: space-between;
  ${({ theme }) => breakpoints.down('sm')} {
    flex-direction: column;
  }

  ${({ theme }) => breakpoints.down('xs')} {
    gap: ${({ theme }) => 'var(--cds-spacing-400)'};
  }
`;

export const MainContent = styled.div`
  margin-bottom: 120px;
  ${({ theme }) => breakpoints.up('sm')} {
    flex-basis: 66%;
  }
`;

export const MainContentHalfWidth = styled.div`
  ${({ theme }) => breakpoints.up('md')} {
    flex-basis: 50%;
  }
`;

export const MainContentFullWidth = styled.div`
  ${({ theme }) => breakpoints.up('sm')} {
    flex-basis: 100%;
  }
`;

export const Sidebar = styled.div`
  ${({ theme }) => breakpoints.up('sm')} {
    flex-basis: 33%;
  }
  ${({ theme }) => breakpoints.down('xs')} {
    order: -1;
  }
`;

export const SidebarHalfWidth = styled.div`
  ${({ theme }) => breakpoints.up('md')} {
    flex-basis: 50%;
  }
  ${({ theme }) => breakpoints.down('xs')} {
    order: -1;
  }
`;
